"use client";

import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

type GraphifySeoCtaLinkProps = {
  pageSlug: string;
  cta: "use_cases" | "build_graph";
  destination: string;
  variant: "primary" | "secondary";
  children: React.ReactNode;
};

export default function GraphifySeoCtaLink({
  pageSlug,
  cta,
  destination,
  variant,
  children,
}: GraphifySeoCtaLinkProps) {
  const className =
    variant === "primary"
      ? "inline-flex items-center justify-center gap-2 rounded-full bg-sky-200 px-6 py-3 text-sm font-semibold text-slate-950 transition hover:bg-white"
      : "inline-flex items-center justify-center rounded-full border border-white/15 px-6 py-3 text-sm font-semibold text-slate-100 transition hover:border-white/35 hover:bg-white/8";

  return (
    <Link
      href={destination}
      prefetch={variant === "primary" ? false : undefined}
      className={className}
      onClick={() =>
        trackEvent("seo_cta_click", {
          page_slug: pageSlug,
          cta,
          destination,
        })
      }
    >
      {children}
      {variant === "primary" ? <ArrowRight className="size-4" /> : null}
    </Link>
  );
}
